// HIRANYA — Size Selection Behavior
(function () {
  function bindSizeEvents() {
    const labels = document.querySelectorAll('.product-form__input input[type="radio"] + label');
    if (!labels.length) return;
    labels.forEach(label => {
      if (label.dataset.bound === 'true') return;
      label.dataset.bound = 'true';
      label.addEventListener('click', function () {
        const group = this.closest('.product-form__input');
        if (group) group.querySelectorAll('label').forEach(l => l.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  function preventAddToCartWithoutSize() {
    const buttons = document.querySelectorAll('form.product-form button[type="submit"]');
    buttons.forEach(button => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', function (e) {
        const form = this.closest('form.product-form');
        const radios = form.querySelectorAll('input[type="radio"]');
        const anyChecked = Array.from(radios).some(r => r.checked);
        if (radios.length && !anyChecked) {
          e.preventDefault();
          const warning = document.createElement('div');
          warning.id = 'size-warning';
          warning.textContent = 'Please select a size before adding to cart';
          this.parentNode.insertBefore(warning, this.nextSibling);
          setTimeout(() => warning.remove(), 4000);
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });
  }

  function initSizeFix() {
    bindSizeEvents();
    preventAddToCartWithoutSize();
  }

  document.addEventListener('DOMContentLoaded', initSizeFix);

  const observer = new MutationObserver(initSizeFix);
  observer.observe(document.body, { childList: true, subtree: true });
})();
